var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.2723 8.95543C9.22412 9.55153 8.51385 10.6733 8.5002 11.9622H5.00009C4.44781 11.9622 3.99358 11.5125 4.06112 10.9644C4.33246 8.76246 5.49019 6.83657 7.16446 5.55833C7.605 5.222 8.22402 5.39087 8.50017 5.87143L10.2723 8.95543ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14ZM13.7278 8.95551L15.5 5.87143C15.7762 5.39087 16.3952 5.222 16.8357 5.55833C18.51 6.83657 19.6677 8.76246 19.9391 10.9644C20.0066 11.5125 19.5524 11.9622 19.0001 11.9622H15.4998C15.4861 10.6734 14.7759 9.55162 13.7278 8.95551ZM12 15.5C12.6418 15.5 13.2433 15.3272 13.7605 15.0257L15.505 18.0616C15.7792 18.5388 15.6182 19.1543 15.1116 19.3694C14.1552 19.7755 13.1037 20 12.0001 20C10.8965 20 9.84503 19.7755 8.88858 19.3694C8.38202 19.1543 8.22097 18.5388 8.49516 18.0616L10.2397 15.0258C10.7568 15.3273 11.3582 15.5 12 15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioactive);
export default __webpack_public_path__ + "static/media/radioactive.eee7c371fe5860eaac1dd5c8beb10e6a.svg";
export { ForwardRef as ReactComponent };